var exports = {
  "Qs": "x43aef4ae--5ca570--content",
  "DD": "x43aef4ae--5ca570--title",
  "VA": "x43aef4ae--5ca570--subtitle",
  "NQ": "x43aef4ae--5ca570--features-list",
  "N4": "x43aef4ae--5ca570--feature",
  "h_": "x43aef4ae--5ca570--description",
  "e4": "x43aef4ae--5ca570--banks",
  "NS": "x43aef4ae--5ca570--author-description",
  "VZ": "x43aef4ae--5ca570--banks-list",
  "pK": "x43aef4ae--5ca570--bank-item",
  "T6": "x43aef4ae--5ca570--banks-title",
};

module.exports = exports;
